import { ApiProperty } from '@nestjs/swagger';
import { IsArray, IsEnum, IsOptional, IsString } from 'class-validator';

export enum DOMEventType {
	CLICK = 'click',
	DBLCLICK = 'dblclick',
	MOUSEENTER = 'mouseenter',
	MOUSELEAVE = 'mouseleave',
	MOUSEOVER = 'mouseover',
	MOUSEOUT = 'mouseout',
	MOUSEDOWN = 'mousedown',
	MOUSEUP = 'mouseup',
	MOUSEMOVE = 'mousemove',
	FOCUS = 'focus',
	BLUR = 'blur',
	CHANGE = 'change',
	INPUT = 'input',
	KEYDOWN = 'keydown',
	KEYUP = 'keyup',
	KEYPRESS = 'keypress',
	SUBMIT = 'submit',
	TOUCHSTART = 'touchstart',
	TOUCHEND = 'touchend',
	TOUCHMOVE = 'touchmove',
	SCROLL = 'scroll',
	RESIZE = 'resize',
	LOAD = 'load',
	UNLOAD = 'unload',
	ANIMATIONSTART = 'animationstart',
	ANIMATIONEND = 'animationend',
	ANIMATIONITERATION = 'animationiteration',
	TRANSITIONSTART = 'transitionstart',
	TRANSITIONEND = 'transitionend'
}

export class ActionDto {
	@ApiProperty({
		description: 'The DOM event type that triggers this action',
		enum: DOMEventType,
		example: DOMEventType.CLICK
	})
	@IsEnum(DOMEventType)
	event: DOMEventType;

	@ApiProperty({
		description:
			'JavaScript code to execute when the event is triggered. Has access to: element (the DOM element), event (the DOM event), state (the ad config object)',
		example: `const hiddenElements = element.querySelectorAll('.hidden');
hiddenElements.forEach(el => {
  el.classList.remove('hidden');
});`
	})
	@IsString()
	script: string;

	@ApiProperty({
		description: 'Optional label for this action',
		required: false
	})
	@IsOptional()
	@IsString()
	label?: string;

	@ApiProperty({
		description: 'Whether this action is enabled',
		default: true,
		required: false
	})
	@IsOptional()
	enabled?: boolean;
}

export class ActionsDto {
	@ApiProperty({
		description: 'Whether actions are enabled for this layer',
		default: false,
		required: false
	})
	@IsOptional()
	enabled?: boolean;

	@ApiProperty({
		description: 'Array of actions for this layer',
		type: [ActionDto],
		required: false
	})
	@IsOptional()
	@IsArray()
	items?: ActionDto[];
}
